module.exports = __webpack_public_path__ + "img/Caminos.48067acf.svg";